import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';

import { useKnownSession } from './session';
import type { SignedInSession } from './session';
import { useLatest } from './utilities/customHooks/useLatest';

const pageViewPropertiesOf = (session: SignedInSession) =>
  session.viewingAs === null
    ? { internalTeam: session.user.isStaff }
    : { viewAsUserName: session.user.name, viewAsUserEmail: session.user.email, internalTeam: session.viewingAs.isStaff };

/** One page view per page, sent once it is known who is looking. */
const PostHogPageViewTracker = () => {
  const location = useLocation();
  const postHog = usePostHog();
  const session = useKnownSession();
  const signedIn = session?.status === 'signedIn' ? session : null;
  const properties = useLatest(signedIn === null ? null : pageViewPropertiesOf(signedIn));
  const known = signedIn !== null;

  useEffect(() => {
    if (!postHog || !known || properties.current === null) return;
    try {
      postHog.capture('$pageview', properties.current);
    } catch {
      return;
    }
  }, [location.key, postHog, known, properties]);

  return null;
};
export default PostHogPageViewTracker;
